module.exports = __webpack_public_path__ + "img/loading.b8113361.gif";